/** Tree registration: the parser. Render wiring lives in `index.r3f.ts`. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseTree } from './parser';
const treeRegistration = {
    typeName: 'Tree',
    parser: parseTree,
};
nodeRegistry.register(treeRegistration);
//# sourceMappingURL=index.js.map